<script>
import { getSitemapEntry } from '../utils'
import { ToArray } from '@/utils'

export default {
  props: {
    value: Object,
    scope: Object,
  },
  data() {
    return {
      items: [],
    }
  },
  computed: {
    residentials() {
      return ToArray(this.value.data.residentials)
    },
  },
  created() {
    Promise.all(
      this.residentials.map(id => {
        return getSitemapEntry(this.scope, id)
      }),
    ).then(e => (this.items = e.map(x => ({ url: x.url, title: x.pagetitle }))))
  },
}
</script>

<template>
  <i18n :path="residentials.length ? 'milestone:lead:multiple' : 'milestone:lead'" tag="div">
    <template #residentials>
      <div data-part="residentials">
        <a v-for="item in items" :href="item.url" target="_blank">{{ item.title }}</a>
      </div>
    </template>
  </i18n>
</template>

<style lang="scss">
.lead-activities__message[data-event='milestone:lead'] {
  [data-part='residentials'] {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 0 0.5rem;
  }
}
</style>
